import { promptVars } from '../variables';
import { structureWithSchemaBasePrompt, } from './structureBasePrompt';
export const generateStructureFormsPrompt = structureWithSchemaBasePrompt
    .temp(0.5)
    .human('Give me a structure of the application.')
    .ai(promptVars.structureDsl)
    .human('Create forms with fields for all entities in the structure. Connect the forms to edit/create scopes related to the entity.');
//# sourceMappingURL=generateStructureFormsPrompt.js.map